import { ReturnCellProps } from "../ReturnsTable.types";

import styles from "../ReturnsTable.module.scss";

export const OrderCell = ({ returnItem }: ReturnCellProps) => (
  <>
    <div className={styles.returnsTable_orderId}>{returnItem.id}</div>

    <div className={styles.returnsTable_orderAddress}>
      {returnItem.deliveryAddressNeighborhood}, {returnItem.deliveryAddressCity}
      , {returnItem.deliveryAddressCountry}
    </div>
  </>
);
